<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="3">
        <el-card shadow="always">
          <small>Fatura Bedeli</small><br>
          {{ HesapVeri.Hesap.FaturaBilgi.tutar }} <sup>TL</sup>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card shadow="always">
          <small>Tüketim Hacmi</small><br>
          {{ HesapVeri.Hesap.FaturaBilgi.hacim }} <sup>kWh</sup>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card shadow="always">
          <small>Sıcak Su</small><br>
          {{ HesapVeri.Hesap.Toplam.sTuketim }} <sup>TL</sup>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card shadow="always">
          <small>Ortak Alan</small><br>
          {{ HesapVeri.Hesap.Toplam.Ortak }} <sup>TL</sup>
        </el-card>
      </el-col>
      <el-col :span="3">
        <el-card shadow="always">
          <small>Şebeke</small><br>
          {{ HesapVeri.Hesap.Toplam.sSebeke }} <sup>TL</sup>
        </el-card>
      </el-col>
      <el-col :span="3" v-if="HesapVeri.Hesap.Ekstra">
        <el-card shadow="always">
          <small>{{ HesapVeri.Hesap.Ekstra }}</small><br>
          {{ HesapVeri.Hesap.eTutar }} <sup>TL</sup>
        </el-card>
      </el-col>
    </el-row>
    <hr>
    <el-row :gutter="24" v-if="HesapVeri">
      <el-col :span="24">
        <table class="table table-bordered table-sayac table-xs table-hover">
          <thead>
          <tr>
            <th>Mesken Bilgi</th>
            <th class="text-right">Okuma Bedeli</th>
            <th class="text-right" v-if="HesapVeri.Hesap.Ekstra">{{ HesapVeri.Hesap.Ekstra }}</th>
            <th class="text-right">Tüketim <sup>(M3)</sup></th>
            <th class="text-right">Şebeke Bedeli</th>
            <th class="text-right">Su Isıtma Bedeli</th>
            <th class="text-right">Ortak Alan</th>
            <th class="text-right">Toplam Ödenecek</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="l in HesapVeri.Liste">
            <td>
              <el-tag size="mini">{{ l.m2 }} <sup>m2</sup></el-tag>
              {{ l.MeskenBilgi }}
            </td>
            <td class="text-right">{{ l.Okuma }} <sup>TL</sup></td>
            <td class="text-right" v-if="HesapVeri.Hesap.eTutar">{{ l.Ekstra }} <sup>TL</sup></td>
            <td class="text-right">{{ l.sBirim }} <sup>M3</sup></td>
            <td class="text-right">{{ l.sSebeke }} <sup>TL</sup></td>
            <td class="text-right">{{ l.sTuketim }} <sup>TL</sup></td>
            <td class="text-right">{{ l.Ortak }} <sup>TL</sup></td>
            <td class="text-right">{{ l.tUcret }} <sup>TL</sup></td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th></th>
            <th class="text-right">{{ HesapVeri.Hesap.OkumaUcreti }} <sup>TL</sup></th>
            <th class="text-right" v-if="HesapVeri.Hesap.eTutar">{{ HesapVeri.Hesap.eTutar }} <sup>TL</sup></th>
            <th class="text-right">{{ HesapVeri.Hesap.Toplam.sBirim }} <sup>M3</sup></th>
            <th class="text-right">{{ HesapVeri.Hesap.Toplam.sSebeke }} <sup>TL</sup></th>
            <th class="text-right">{{ HesapVeri.Hesap.Toplam.sTuketim }} <sup>TL</sup></th>
            <th class="text-right">{{ HesapVeri.Hesap.Toplam.Ortak }} <sup>TL</sup></th>
            <th class="text-right">{{ HesapVeri.Hesap.Toplam.tUcret }} <sup>TL</sup></th>
          </tr>
          </tfoot>
        </table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['HesapVeri'],
  data() {
    return {

      AltToplam: {
        Okuma: 0,
        SicakSum3: 0,
        SicakSuBirim: 0,
        SicakSu: 0,
        tUcret: 0,
      }
    }
  },
  methods: {},
  created() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Donem/YazHesaplamasi.vue